import pluralize from "pluralize";
import React from "react";

import {
  gaEvent,
  virtualPageView,
} from "../../shared/helpers/gtm_tracking";

import Rounds from "./Rounds";
import Select from "./Select";

class TeeTimesForm extends React.Component {
  constructor() {
    super();

    this.buttonLabel = "Proceed to checkout";
  }

  componentWillMount() {
    this._setDefaultState(this.props.paxOptions[0]);
  }

  _trackCTAClick = () => {
    gaEvent("Last Minute Page", "Deal", this.buttonLabel);
    virtualPageView("BOOKING_PERSONAL_DETAILS");
  };

  _formatPax = pax => pluralize("golfer", pax, true);

  _countIn = (target, val) => target.filter(x => x === val).length;

  _coursesOrderedByCount = coursesByDate =>
    Object.keys(coursesByDate)
      .map(date => [date].concat(coursesByDate[date]))
      .sort((a, b) => a.length - b.length);

  _selectedCourses = coursesOrderedByCount =>
    coursesOrderedByCount.reduce((obj, el) => {
      const [date, ...courses] = el;
      const currentRounds = Object.values(obj);

      const selectedCourse = courses.find(course => {
        const availableRoundsForCourse = this.props.roundsByCourse[course];
        const currentRoundsForCourse = this._countIn(currentRounds, course);

        return currentRoundsForCourse < availableRoundsForCourse;
      });

      return {
        ...obj,
        [date]: selectedCourse
      };
    }, {});

  _selectedTimes = (selectedCourses, teeTimes) =>
    Object.keys(selectedCourses).reduce((obj, date) => {
      const selectedCourse = selectedCourses[date];
      const firstTime = this.timesForDateAndCourse(teeTimes, date, selectedCourse)[0];

      return {
        ...obj,
        [date]: firstTime.id
      };
    }, {});

  _setDefaultState = selectedPax => {
    const availableTimes = this.props.teeTimes
      .filter(time => time.pax.includes(Number(selectedPax)));
    const coursesByDate = this.coursesByDate(availableTimes);
    const coursesOrderedByCount = this._coursesOrderedByCount(coursesByDate);
    const selectedCourses = this._selectedCourses(coursesOrderedByCount);
    const selectedTimes = this._selectedTimes(selectedCourses, availableTimes);

    this.setState({
      availableTimes,
      selectedPax,
      selectedCourses,
      selectedTimes
    });
  };

  coursesByDate = teeTimes =>
    teeTimes.reduce((obj, time) => {
      const courses = obj[time.date] || [];

      if (!courses.includes(time.course)) {
        courses.push(time.course);
      }

      return {
        ...obj,
        [time.date]: courses.sort()
      };
    }, {});

  timesForDateAndCourse = (teeTimes, date, course) =>
    teeTimes
      .filter(time => time.date === date && time.course === course)
      .sort((a, b) => {
        return a.band < b.band || a.time < b.time ? -1 : 1;
      });

  handlePaxSelect = e => {
    this._setDefaultState(e.target.value);
  };

  handleCourseSelect = (course, date) => {
    const swapDate = Object.keys(this.state.selectedCourses)
      .filter(d => this.state.selectedCourses[d] === course);

    const selectedCourses = {
      ...this.state.selectedCourses,
      [date]: course,
      [swapDate]: this.state.selectedCourses[date]
    };

    const selectedTimes = this._selectedTimes(selectedCourses, this.state.availableTimes);

    this.setState({ selectedCourses, selectedTimes });
  };

  handleTimeSelect = (timeId, date) => {
    this.setState(prevState => ({
      selectedTimes: {
        ...prevState.selectedTimes,
        [date]: timeId
      }
    }));
  };

  proceedToCheckout = () => {
    this._trackCTAClick();
    this.props.proceedToCheckout(this.state.selectedPax, this.state.selectedTimes);
  };

  render() {
    const {
      boardBasis,
      formattedDate,
      paxOptions
    } = this.props;

    const selectedPax = this.state.selectedPax;
    const formattedPax = this._formatPax(selectedPax);

    const paxProps = {
      options: paxOptions.map(p => ({ value: p, text: this._formatPax(p) })),
      selected: { value: selectedPax, text: formattedPax },
      handleSelect: this.handlePaxSelect
    };

    return (
      <div>
        <div className="venue__offer__content">
          <div className="venue__offer__subtitle">
            <strong>{boardBasis}</strong> for <Select {...paxProps} />
            <span> arriving on </span><strong>{formattedDate}</strong>
          </div>

          <Rounds
            coursesByDate={this.coursesByDate(this.state.availableTimes)}
            selectedCourses={this.state.selectedCourses}
            handleCourseSelect={this.handleCourseSelect}
            teeTimes={this.state.availableTimes}
            timesForDateAndCourse={this.timesForDateAndCourse}
            selectedTimes={this.state.selectedTimes}
            handleTimeSelect={this.handleTimeSelect}
          />
        </div>

        <div className="venue__offer__ctas">
          <button
            className="venue__offer__cta button button--alt--solid gtm-track-click"
            onClick={this.proceedToCheckout}
          >
            {this.buttonLabel}
          </button>
        </div>
      </div>
    );
  }
}

export default TeeTimesForm;



// WEBPACK FOOTER //
// ./components/last_minute_deals/TeeTimesForm.js